import React from 'react';

const OurHistory = () => {
  return (
    <div className="mt-5 container">
      <div className="niboooo">
        <div className="container">
          <div className="ursiy">
            <span>Our History</span>
          </div>
          <div className="weare">
            We’re a cross-disciplinary team that loves to create great
            experiences for our customers.
          </div>
          <div className="reminddd">
            <div className="ckassic">
              <div className="billz">
                <div className="pboyqq">
                  <div className="yearr">2010</div>
                  <div className="opening">
                    Opening of <br /> Cameroon <br /> Office
                  </div>
                </div>
              </div>

              <div className="billz twooo">
                <div className="pboyqq">
                  <div className="yearr">2011</div>
                  <div className="opening">
                    Opening of <br /> Lima Oil Base
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginTop: '80px' }}>
            <div className="ursiy">
              <span>Our Values</span>
            </div>
            <div className="weare">
              Provide high quality international logistics solutions that are
              profitable and tailored to the needs of our clients, from all
              industries. We rely on our know-how and on the professionalism of
              our teams to develop a lasting partnership based on transparency,
              exchange, respect and trust with our clients.
            </div>
          </div>
          <div className="wilburr">
            <div className="row">
              <div className="col-12 col-lg-4 mb-4">
                <div className="lamooo">
                  <div>
                    <span>
                      <svg
                        width="46"
                        height="47"
                        viewBox="0 0 46 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.5"
                          width="46"
                          height="46"
                          rx="8"
                          fill="#102845"
                        />
                        <path
                          d="M27.1775 32.3125C25.8726 32.9334 24.4451 33.2538 23 33.25C17.624 33.25 13.25 28.876 13.25 23.5C13.25 21.1937 14.0428 19.0157 15.5 17.269V19H17V14.5H12.5V16H14.6315C12.772 18.0548 11.7447 20.7287 11.75 23.5C11.75 29.7032 16.7968 34.75 23 34.75C24.6683 34.7542 26.3163 34.3841 27.8225 33.667L27.1775 32.3125Z"
                          fill="white"
                        />
                        <path
                          d="M26.75 18.25C24.38 18.25 22.4368 20.0928 22.2665 22.42C21.4419 21.6677 20.3662 21.2505 19.25 21.25H16.25V24.25C16.25 26.7318 18.269 28.75 20.75 28.75H22.25V31.75H23.75V25.75H25.25C27.731 25.75 29.75 23.7318 29.75 21.25V18.25H26.75ZM20.75 27.25C19.0955 27.25 17.75 25.9045 17.75 24.25V22.75H19.25C20.9045 22.75 22.25 24.0955 22.25 25.75V26.1895L20.5302 24.4697L19.4698 25.5303L21.1895 27.25H20.75ZM28.25 21.25C28.25 22.9045 26.9045 24.25 25.25 24.25H24.8105L26.5303 22.5302L25.4697 21.4698L23.75 23.1895V22.75C23.75 21.0955 25.0955 19.75 26.75 19.75H28.25V21.25Z"
                          fill="white"
                        />
                        <path
                          d="M34.25 23.5C34.25 17.2967 29.2032 12.25 23 12.25C21.3317 12.2457 19.6838 12.6158 18.1775 13.333L18.8225 14.6875C20.1274 14.0666 21.5549 13.7462 23 13.75C28.376 13.75 32.75 18.124 32.75 23.5C32.75 25.8062 31.9572 27.9842 30.5 29.731V28H29V32.5H33.5V31H31.3685C33.228 28.9451 34.2553 26.2713 34.25 23.5Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="sus">
                    <span>Sustainability</span>
                  </div>
                  <div className="climate">
                    <span>
                      We run our business in an ethical, healthy and safe way
                      that creates a climate fit for life; we cherish financial
                      success and return on investment while delivering the
                      highest standards in quality.
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 mb-4">
                <div className="lamooo">
                  <div>
                    <span>
                      <svg
                        width="46"
                        height="47"
                        viewBox="0 0 46 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.5"
                          width="46"
                          height="46"
                          rx="8"
                          fill="#102845"
                        />
                        <path
                          d="M32 22.5C32 28.05 28.16 33.24 23 34.5C17.84 33.24 14 28.05 14 22.5V16.5L23 12.5L32 16.5V22.5ZM23 32.5C26.75 31.5 30 27.04 30 22.72V17.8L23 14.68L16 17.8V22.72C16 27.04 19.25 31.5 23 32.5ZM21 28.5L17 24.5L18.41 23.09L21 25.67L27.59 19.08L29 20.5"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="sus">
                    <span>Proactivity</span>
                  </div>
                  <div className="climate">
                    <span>
                      We anticipate potential risks and develop solutions for
                      our clients.
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 mb-4">
                <div className="lamooo">
                  <div>
                    <span>
                      <svg
                        width="46"
                        height="47"
                        viewBox="0 0 46 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.5"
                          width="46"
                          height="46"
                          rx="8"
                          fill="#102845"
                        />
                        <path
                          d="M29 24.5L25 25.5M33 32.5H26.5L25.022 25.6035C25.0073 25.5346 25 25.4644 25 25.394V19L21.285 16.018C21.0931 15.8638 20.9661 15.6431 20.9293 15.3996C20.8926 15.1562 20.9487 14.9078 21.0866 14.7038C21.2245 14.4998 21.434 14.3551 21.6736 14.2985C21.9132 14.2418 22.1654 14.2773 22.38 14.398L27 17L28.9735 24.4015C28.991 24.467 29.0155 24.5305 29.0455 24.5915L33 32.5Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16 24L19 25.5M20.6895 24.26L20.7215 24.287C20.8324 24.3798 20.9622 24.4474 21.1018 24.4852C21.2414 24.523 21.3875 24.5301 21.5301 24.5059C21.6727 24.4818 21.8083 24.427 21.9277 24.3454C22.0471 24.2637 22.1473 24.1571 22.2215 24.033L23 22.7315V20.385L21.16 19L17.98 19.423L15.9075 23.471C15.8825 23.519 15.8615 23.5695 15.845 23.621L13 32.5H18.98V26L19.5 23.5435L19.75 22.5H20.5L20.348 23.3085C20.3152 23.4832 20.3295 23.6635 20.3895 23.8309C20.4495 23.9982 20.5531 24.146 20.6895 24.26Z"
                          stroke="white"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="sus">
                    <span>Respect</span>
                  </div>
                  <div className="climate">
                    <span>
                      We value differences, believe in the importance of all our
                      employees and build relationships based on trust and
                      mutual goals.{' '}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 mb-4">
                <div className="lamooo">
                  <div>
                    <span>
                      <svg
                        width="46"
                        height="47"
                        viewBox="0 0 46 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.5"
                          width="46"
                          height="46"
                          rx="8"
                          fill="#102845"
                        />
                        <path
                          d="M22.861 13.89C23.3449 13.5675 23.912 13.3927 24.4935 13.3866C25.0749 13.3806 25.6455 13.5437 26.136 13.856L30.29 16.5H32C32.2652 16.5 32.5196 16.6053 32.7071 16.7929C32.8946 16.9804 33 17.2348 33 17.5V26.5C33 26.7652 32.8946 27.0196 32.7071 27.2071C32.5196 27.3946 32.2652 27.5 32 27.5H30.48C30.5121 27.9869 30.4091 28.4733 30.1823 28.9054C29.9556 29.3375 29.6139 29.6987 29.195 29.949L24.102 33.005C23.7891 33.1926 23.4308 33.291 23.0659 33.2896C22.701 33.2882 22.3435 33.187 22.032 32.997C21.6812 33.307 21.2327 33.4841 20.7647 33.4974C20.2968 33.5107 19.8389 33.3595 19.471 33.07L14.331 29.031C13.9719 28.7489 13.72 28.3525 13.6172 27.9076C13.5144 27.4627 13.5669 26.996 13.766 26.585C13.5272 26.3978 13.3341 26.1587 13.2014 25.8858C13.0687 25.6129 12.9998 25.3134 13 25.01V17.5C13 17.2348 13.1054 16.9804 13.2929 16.7929C13.4804 16.6053 13.7348 16.5 14 16.5H18.947L22.861 13.89ZM15.173 25.146L15.865 24.541C16.4564 24.0237 17.2271 23.759 18.0115 23.8039C18.796 23.8488 19.5315 24.1996 20.06 24.781L22.762 27.753C23.1857 28.2191 23.452 28.8067 23.5231 29.4325C23.5941 30.0584 23.4664 30.6908 23.158 31.24L28.167 28.235C28.298 28.1562 28.3974 28.0342 28.4482 27.89C28.4989 27.7458 28.4978 27.5884 28.445 27.445L24.018 21.247C23.8968 21.0771 23.7254 20.9494 23.528 20.8818C23.3306 20.8142 23.1169 20.8101 22.917 20.87L20.431 21.615C19.9122 21.7706 19.361 21.7828 18.8358 21.6504C18.3106 21.518 17.831 21.2459 17.448 20.863L17.155 20.571C16.8889 20.3055 16.7032 19.9703 16.6192 19.6039C16.5352 19.2375 16.5562 18.8549 16.68 18.5H15V25.01L15.173 25.146ZM25.063 15.544C24.8993 15.4397 24.7088 15.3853 24.5147 15.3874C24.3206 15.3896 24.1314 15.4481 23.97 15.556L18.57 19.156L18.862 19.449C18.9898 19.5766 19.1498 19.6673 19.325 19.7113C19.5002 19.7553 19.684 19.7511 19.857 19.699L22.342 18.954C22.9416 18.7742 23.5825 18.7864 24.1748 18.9891C24.7671 19.1917 25.2812 19.5746 25.645 20.084L29.515 25.5H31V18.5H30.291C29.9105 18.4999 29.5379 18.3914 29.217 18.187L25.063 15.544ZM17.181 26.045L15.565 27.459L20.705 31.498L21.41 30.266C21.5148 30.0825 21.5587 29.8705 21.5355 29.6605C21.5123 29.4505 21.4232 29.2532 21.281 29.097L18.58 26.125C18.4038 25.9313 18.1587 25.8144 17.8973 25.7995C17.6359 25.7845 17.3781 25.8727 17.181 26.045Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="sus">
                    <span>Integrity</span>
                  </div>
                  <div className="climate">
                    <span>
                      We value honesty, commitment and respect when dealing with
                      colleagues and customers.{' '}
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 mb-4">
                <div className="lamooo">
                  <div>
                    <span>
                      <svg
                        width="45"
                        height="47"
                        viewBox="0 0 45 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.5"
                          width="45"
                          height="46"
                          rx="8"
                          fill="#102845"
                        />
                        <path
                          d="M12.0679 31.5469V25.3411L17.2708 23.0149L22.4737 25.3429V31.5469L17.2708 33.8714L12.0679 31.5469Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M12.0679 25.3291L17.2708 27.6554L22.4737 25.3291M17.2708 16.852L22.4721 19.18L27.675 16.8537"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M22.472 25.3291L27.675 27.6554L32.8779 25.3291"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M17.2708 27.6589V33.8731M27.6783 27.6589V33.8731M22.472 19.18V25.3926M17.274 23.0114V16.8057L22.4753 14.4794L27.6783 16.8057V23.0114L22.4753 25.3377L17.274 23.0114ZM22.472 31.5469V25.3411L27.675 23.0149L32.8779 25.3429V31.5469L27.675 33.8714L22.472 31.5469Z"
                          stroke="white"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="sus">
                    <span>Innovation</span>
                  </div>
                  <div className="climate">
                    <span>
                      We encourage our employees to innovate and invest into the
                      future to improve our lives, workplace and the way we do
                      things
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-12 col-lg-4 mb-4">
                <div className="lamooo">
                  <div>
                    <span>
                      <svg
                        width="46"
                        height="47"
                        viewBox="0 0 46 47"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <rect
                          y="0.5"
                          width="46"
                          height="46"
                          rx="8"
                          fill="#102845"
                        />
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M22 15.5C21.606 15.5 21.2159 15.5776 20.8519 15.7284C20.488 15.8791 20.1573 16.1001 19.8787 16.3787C19.6001 16.6573 19.3791 16.988 19.2284 17.3519C19.0776 17.7159 19 18.106 19 18.5C19 18.894 19.0776 19.2841 19.2284 19.6481C19.3791 20.012 19.6001 20.3427 19.8787 20.6213C20.1573 20.8999 20.488 21.1209 20.8519 21.2716C21.2159 21.4224 21.606 21.5 22 21.5C22.7956 21.5 23.5587 21.1839 24.1213 20.6213C24.6839 20.0587 25 19.2956 25 18.5C25 17.7044 24.6839 16.9413 24.1213 16.3787C23.5587 15.8161 22.7956 15.5 22 15.5ZM17 18.5C17 17.1739 17.5268 15.9021 18.4645 14.9645C19.4021 14.0268 20.6739 13.5 22 13.5C23.3261 13.5 24.5979 14.0268 25.5355 14.9645C26.4732 15.9021 27 17.1739 27 18.5C27 19.8261 26.4732 21.0979 25.5355 22.0355C24.5979 22.9732 23.3261 23.5 22 23.5C20.6739 23.5 19.4021 22.9732 18.4645 22.0355C17.5268 21.0979 17 19.8261 17 18.5ZM15.413 29.101C15.09 29.511 15 29.821 15 30C15 30.122 15.037 30.251 15.255 30.426C15.504 30.626 15.937 30.833 16.599 31.008C17.917 31.358 19.811 31.5 22 31.5C22.222 31.5 22.441 31.498 22.658 31.495C22.9232 31.4914 23.179 31.5933 23.3691 31.7783C23.5591 31.9634 23.6679 32.2163 23.6715 32.4815C23.6751 32.7467 23.5732 33.0025 23.3882 33.1926C23.2031 33.3826 22.9502 33.4914 22.685 33.495C22.459 33.498 22.23 33.5 22 33.5C19.771 33.5 17.665 33.36 16.087 32.942C15.302 32.734 14.563 32.436 14.003 31.986C13.41 31.51 13 30.845 13 30C13 29.213 13.358 28.477 13.844 27.861C14.338 27.236 15.021 26.661 15.822 26.171C17.425 25.195 19.605 24.5 22 24.5C22.447 24.5 22.887 24.524 23.316 24.57C23.5798 24.598 23.8216 24.7296 23.9883 24.9359C24.155 25.1422 24.233 25.4062 24.205 25.67C24.177 25.9338 24.0454 26.1756 23.8391 26.3423C23.6328 26.509 23.3688 26.587 23.105 26.559C22.745 26.52 22.375 26.5 22 26.5C19.977 26.5 18.157 27.09 16.864 27.879C16.217 28.273 15.728 28.701 15.413 29.101ZM29.316 25.551C29.1109 25.4827 28.8891 25.4827 28.684 25.551L25.684 26.551C25.4848 26.6173 25.3115 26.7447 25.1888 26.915C25.066 27.0854 24.9999 27.29 25 27.5V29.171C24.9999 30.2406 25.3942 31.2727 26.1075 32.0698C26.8207 32.8668 27.8029 33.3729 28.866 33.491C28.956 33.501 29.045 33.501 29.134 33.491C30.1971 33.3729 31.1793 32.8668 31.8925 32.0698C32.6058 31.2727 33.0001 30.2406 33 29.171V27.5C33.0001 27.29 32.934 27.0854 32.8112 26.915C32.6885 26.7447 32.5152 26.6173 32.316 26.551L29.316 25.551ZM27 29.171V28.221L29 27.554L31 28.221V29.171C31 30.338 30.145 31.321 29 31.492C28.444 31.4091 27.9362 31.1293 27.5691 30.7035C27.202 30.2776 27.0001 29.7342 27 29.172V29.171Z"
                          fill="white"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="sus">
                    <span>Talent Development </span>
                  </div>
                  <div className="climate">
                    <span>
                      We nourish and prepare tomorrows leaders and workforce for
                      future challenges.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OurHistory;
